export const validateFields = (fieldsToValidate, state) => {
  const emptyFields = fieldsToValidate
    .filter((field) => !state[field.key]?.trim())
    .map((field) => field.label);

  return emptyFields;
};
